<template>
  <div class="product-detail">
    <fn-product-reviews
      :product="product"
      :reviews-script="reviewsScript"
    />
  </div>
</template>

<script lang="ts">
export default defineComponent({
  props: {
    product: {
      type: Object,
      required: true,
    },
    reviewsScript: {
      type: String,
      default: '',
    },
  },
});
</script>
